import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import { PortfolioAddSuccessPage } from "web_myplann/Portfolio/PortfolioShared/PortfolioAddSuccessPage";

export const AddLoansSuccessPage = () => (
	<PortfolioAddSuccessPage namespace={Resources.Portfolio.AddShared} />
);
